<template>
    <div id="Personal__Training" class="d-flex">
        <CardTemplate>
            <!-- HEADER -->
            <template v-slot:header>
                <section class="card-title">
                    <span>
                        {{ videoData?.Title }}
                    </span>
                </section>
                <section class="ms-auto card-heading-options">
                    <a
                        href="https://www.axxess.com/on_demand/"
                        class="heading-option flex-row py-2 my-n1"
                        target="_blank"
                    >
                        <i class="icon fas fa-video"></i>
                        <span class="text ms-1">More Training Videos</span>
                    </a>
                </section>
            </template>
            <!-- CONTENT -->
            <!-- LOADING -->
            <template v-slot:content>
                <div class="mt-3 text-center" v-show="isLoading && !hasError">
                    <i class="fas fa-spinner fa-pulse fa-fw"></i>
                    <b>Loading Video</b>
                    <i class="fas fa-spinner fa-pulse fa-fw"></i>
                </div>
                <!-- ERROR -->
                <div class="mt-5 text-center" v-show="hasError && !isLoading">
                    <p>
                        There was a problem while fetching the video.
                        <br />
                        Please try again.
                    </p>
                    <button class="btn btn-primary" @click="getVideo">Try Again</button>
                </div>
                <!-- DATA -->
                <div class="w-100 h-100" v-show="!isLoading && !hasError && videoData">
                    <section class="personal-training-video w-100 h-100" v-html="videoData?.Text"></section>
                </div>
            </template>
        </CardTemplate>
    </div>
</template>

<script lang="ts" src="./PersonalTraining.ts"></script>
<style src="./PersonalTraining.scss"></style>
